window.addEventListener("load", function () {
    var container = document.getElementById('secret_container'),
        subscribe_form_container = document.getElementById('form_container');
    if(subscribe_form_container) {
        var subscribe_form = document.getElementById('form_container').dataset.form_id;
        jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
            if (formId == subscribe_form) {
                var data = {
                    action: 'seven_secret',
                    page_url: window.location.pathname
                };
                jQuery.post(
                    seven_secret_ajax.url,
                    data,
                    function (response) {
                        container.innerHTML = response;
                    });
            }
        });
    }
    
});